import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil, tap } from 'rxjs';
import { SnackbarService } from './snackbar.service';
import { SnackbarStatus } from './snackbar-status.enum';

@Component({
  selector: 'prism-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent implements OnInit, OnDestroy {


  public SnackbarStatus = SnackbarStatus;

  public mainMessage$: BehaviorSubject<string> = new BehaviorSubject('');
  public previousMessage$: BehaviorSubject<string> = new BehaviorSubject('');
  public switch$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    public snackbarService: SnackbarService
  ) { }


  private unsubscribe$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    this.snackbarService.message$.pipe(
      tap(newMessage => {
        this.previousMessage$.next(this.mainMessage$.value);
        this.mainMessage$.next(newMessage);
        this.switch$.next(true);
        setTimeout(() => this.previousMessage$.next(''), 300)
        setTimeout(() => {
          this.switch$.next(false);
        }, 2000)
      }),
      takeUntil(this.unsubscribe$)
    ).subscribe();


    this.snackbarService.show$.pipe(
      tap(show => {
        if (!show) {
          this.previousMessage$.next('');
          this.switch$.next(false);
        }
      }),
      takeUntil(this.unsubscribe$)
    ).subscribe();

  }


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
